module.exports = require('./$.hide');


//////////////////
// WEBPACK FOOTER
// ./~/react-relay/~/core-js/library/modules/$.redefine.js
// module id = 515
// module chunks = 0